(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["store-information-ticker"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (customElements.get('store-information-ticker')) return;
  class StoreInformationTicker extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.st-track');
      this.group = this.querySelector('.st-group');
      this.viewport = this.querySelector('.st-viewport');
      if (!this.track || !this.group || !this.viewport) return;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 767px)');
      this.hoverable = matchMedia('(hover: hover) and (pointer: fine)');
      this.hoverPause = false;
      this.focusPause = false;
      this.addEventListener('pointerenter', () => { this.hoverPause = this.hoverable.matches; this.sync(); }, { signal });
      this.addEventListener('pointerleave', () => { this.hoverPause = false; this.sync(); }, { signal });
      this.addEventListener('focusin', e => { this.focusPause = Boolean(e.target.closest('a')); if (this.focusPause && this.animation) { this.animation.currentTime = 0; } this.sync(); e.target.scrollIntoView({block:'nearest',inline:'nearest'}); }, { signal });
      this.addEventListener('focusout', () => { queueMicrotask(() => { this.focusPause = this.contains(document.activeElement) && Boolean(document.activeElement.closest('a')); this.sync(); }); }, { signal });
      this.reduced.addEventListener('change', () => this.sync(), { signal });
      this.mobile.addEventListener('change', () => this.schedule(), { signal });
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.group);
      this.contentObserver = new MutationObserver(() => this.schedule());
      this.contentObserver.observe(this.group, { childList: true, subtree: true, characterData: true });
      if (document.fonts) {
        document.fonts.ready.then(() => { if (!signal.aborted) this.schedule(); });
        document.fonts.addEventListener('loadingdone', () => this.schedule(), { signal });
      }
      this.measure();
    }
    schedule() {
      if (!this.controller || this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.measure(); });
    }
    measure() {
      const width = this.group.getBoundingClientRect().width;
      const viewportWidth = this.viewport.clientWidth;
      if (!width || !viewportWidth) return;
      const speed = this.mobile.matches ? 28 : 34;
      const duration = width / speed * 1000;
      const copies = Math.max(1, Math.ceil(viewportWidth / width));
      if (this.distance === width && this.speed === speed && this.copies === copies) { this.sync(); return; }
      const progress = this.animation && this.duration ? (Number(this.animation.currentTime || 0) % this.duration) / this.duration : 0;
      this.animation?.cancel();
      this.track.querySelectorAll('[data-st-copy]').forEach(node => node.remove());
      for (let i = 0; i < copies; i++) {
        const clone = this.group.cloneNode(true);
        clone.dataset.stCopy = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node => node.tabIndex = -1);
        this.track.append(clone);
      }
      this.distance = width;
      this.duration = duration;
      this.speed = speed;
      this.copies = copies;
      this.animation = this.track.animate([{ transform: 'translateX(0)' }, { transform: `translateX(-${width}px)` }], { duration, iterations: Infinity, easing: 'linear' });
      this.animation.currentTime = progress * duration;
      this.dataset.ready = '';
      this.sync();
    }
    sync() {
      if (!this.controller) return;
      const stopped = this.reduced.matches || this.hoverPause || this.focusPause;
      if (this.animation) stopped ? this.animation.pause() : this.animation.play();
      if (!this.focusPause && !this.reduced.matches) this.viewport.scrollLeft = 0;
      this.toggleAttribute('data-reduced', this.reduced.matches);
      if (this.reduced.matches && this.animation) this.animation.currentTime = 0;
      this.dataset.paused = String(stopped);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.resizeObserver?.disconnect(); this.contentObserver?.disconnect();
      this.animation?.cancel(); this.animation = null;
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.track?.querySelectorAll('[data-st-copy]').forEach(node => node.remove());
      this.distance = null; this.removeAttribute('data-ready');
    }
  }
  customElements.define('store-information-ticker', StoreInformationTicker);
})();
  } catch(e) { console.error(e); }
})();

})();
